// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__hPvzj","productName":"Table_productName__1g1p1"};